import { render, staticRenderFns } from "./AboutUsGloboSection.vue?vue&type=template&id=7a2d4c48"
import script from "./AboutUsGloboSection.vue?vue&type=script&lang=ts"
export * from "./AboutUsGloboSection.vue?vue&type=script&lang=ts"
import style0 from "./AboutUsGloboSection.vue?vue&type=style&index=0&id=7a2d4c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports